(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6859],{

/***/ 20816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Bookmark; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * lucide-react v0.243.0 - ISC
 */



const Bookmark = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Bookmark", [
  [
    "path",
    { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }
  ]
]);


//# sourceMappingURL=bookmark.js.map


/***/ }),

/***/ 57420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Heart; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84297);
/**
 * lucide-react v0.243.0 - ISC
 */



const Heart = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("Heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);


//# sourceMappingURL=heart.js.map


/***/ }),

/***/ 38383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64998);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74183);




var Breadcrumbs = function(param) {
    var list = param.list;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: "flex",
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
            className: "inline-flex items-center",
            children: list.filter(Boolean).map(function(it, index) {
                var isLast = index === list.length - 1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "inline-flex items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("inline-flex items-center text-[0.625rem] font-medium", {
                            "text-muted-foreground": !isLast
                        }),
                        children: [
                            it.name,
                            !isLast && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                className: "inline-flex w-4 h-4 text-slate-700"
                            })
                        ]
                    })
                }, it.id);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 1979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ Side; },
/* harmony export */   "p": function() { return /* binding */ CommentsDialog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_ui_sheet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77739);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var Side;
(function(Side) {
    Side["Right"] = "right";
    Side["Top"] = "top";
    Side["Bottom"] = "bottom";
    Side["Left"] = "left";
})(Side || (Side = {}));
function CommentsDialog(param) {
    var _side = param.side, side = _side === void 0 ? Side.Right : _side, triggerElement = param.triggerElement, children = param.children, open = param.open, onOpenChange = param.onOpenChange;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_sheet__WEBPACK_IMPORTED_MODULE_1__/* .Sheet */ .yo, {
        open: open,
        onOpenChange: onOpenChange,
        children: [
            triggerElement ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_sheet__WEBPACK_IMPORTED_MODULE_1__/* .SheetTrigger */ .aM, {
                asChild: true,
                children: triggerElement
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_sheet__WEBPACK_IMPORTED_MODULE_1__/* .SheetContent */ .ue, {
                side: side,
                className: "w-full max-w-screen sm:w-1/2 lg:w-1/3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_sheet__WEBPACK_IMPORTED_MODULE_1__/* .SheetHeader */ .Tu, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_sheet__WEBPACK_IMPORTED_MODULE_1__/* .SheetTitle */ .bC, {
                            children: "Members' reactions"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col gap-4 py-4 h-full",
                        children: children
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 95642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ ToolboxCommentsList; },
/* harmony export */   "j": function() { return /* binding */ CaseCommentsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46035);
/* harmony import */ var _features_casesSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94916);
/* harmony import */ var _features_toolboxSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67576);
/* harmony import */ var _features_commentsSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12763);
/* harmony import */ var _util_format__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16685);
/* harmony import */ var _features_usersSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97219);
/* harmony import */ var _features_toolsSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62395);
/* harmony import */ var _features_timezoneSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70118);
/* harmony import */ var _ui_scroll_area__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92447);
/* harmony import */ var _components_UserAvatar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8222);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74183);













var CaseCommentsList = function(param) {
    var caseId = param.caseId, blurComments = param.blurComments;
    var currentCase = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_features_casesSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCaseById */ .pJ)(state, caseId);
    });
    if (!currentCase) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommentsListContainer, {
        comments: currentCase.comments,
        blurComments: blurComments
    });
};
var ToolboxCommentsList = function(param) {
    var toolboxId = param.toolboxId, toolId = param.toolId;
    var currentToolbox = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_features_toolboxSlice__WEBPACK_IMPORTED_MODULE_4__/* .selectToolboxById */ .Km)(state, toolboxId);
    });
    var currentTool = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return toolId ? (0,_features_toolsSlice__WEBPACK_IMPORTED_MODULE_8__/* .selectToolById */ .Ex)(state, toolId) : null;
    });
    if (toolId && !currentTool) {
        return null;
    }
    if (!currentToolbox) {
        return null;
    }
    var comments = (toolId ? (currentTool === null || currentTool === void 0 ? void 0 : currentTool.comments) || [] : currentToolbox.comments) || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommentsListContainer, {
        comments: comments
    });
};
var CommentsListContainer = function(param) {
    var comments = param.comments, blurComments = param.blurComments;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_scroll_area__WEBPACK_IMPORTED_MODULE_10__/* .ScrollArea */ .x, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_12__.cn)("h-full w-full"),
        style: {
            filter: blurComments ? "blur(4px) grayscale(1)" : undefined
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "grid gap-6",
            children: (comments || []).map(function(id) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comment, {
                    commentId: id
                }, id);
            })
        })
    });
};
var Comment = function(param) {
    var commentId = param.commentId;
    var ref;
    var comment = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_features_commentsSlice__WEBPACK_IMPORTED_MODULE_5__/* .selectCommentById */ .o1)(state, commentId);
    });
    var timezone = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_features_timezoneSlice__WEBPACK_IMPORTED_MODULE_9__/* .selectTimezone */ .pE);
    var commentAuthor = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,_features_usersSlice__WEBPACK_IMPORTED_MODULE_7__/* .selectUserById */ .Ls)(state, comment.user);
    });
    if (!comment || !comment.content || (comment === null || comment === void 0 ? void 0 : (ref = comment.content) === null || ref === void 0 ? void 0 : ref.length) < 3) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center justify-between space-x-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-start space-x-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UserAvatar__WEBPACK_IMPORTED_MODULE_11__/* .UserAvatar */ .Y, {
                    userId: comment.user
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm font-medium leading-none",
                            children: (0,_util_format__WEBPACK_IMPORTED_MODULE_6__/* .formatName */ .KY)(commentAuthor)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm text-muted-foreground",
                            children: (0,_util_format__WEBPACK_IMPORTED_MODULE_6__/* .formatDate */ .p6)({
                                ts: comment.created,
                                tz: timezone
                            })
                        }),
                        (0,_util_format__WEBPACK_IMPORTED_MODULE_6__/* .prepareText */ .hN)(comment.content || "").map(function(line, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-sm",
                                children: line
                            }, index);
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 5895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ContentSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./util/format.ts + 9 modules
var format = __webpack_require__(16685);
;// CONCATENATED MODULE: ./components/TextContent.tsx



var TextContent = function(param) {
    var content = param.content, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: (0,format/* prepareText */.hN)(content || "").map(function(it, index, parts) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: it
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ./components/HtmlContent.js


var HtmlContent = function(param) {
    var content = param.content, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};

// EXTERNAL MODULE: ./components/ui/typography.tsx
var typography = __webpack_require__(58020);
;// CONCATENATED MODULE: ./components/ContentSection.tsx





var ContentSection = function(props) {
    var content = props.content, htmlContent = props.htmlContent, id = props.id, media = props.media, title = props.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "my-8 flex flex-col gap-2",
        id: id,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                variant: "h3",
                children: title
            }),
            content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: htmlContent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlContent, {
                    content: content,
                    className: "prose"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent, {
                    content: content,
                    className: "prose"
                })
            }),
            media && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-4",
                children: media
            })
        ]
    });
};
/* harmony default export */ var components_ContentSection = (ContentSection);


/***/ }),

/***/ 76102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74183);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35739);
/* harmony import */ var _components_ui_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64345);





var GiveFeedbackCta = function(param) {
    var onClick = param.onClick, className = param.className, _title = param.title, title = _title === void 0 ? "What do you think about this?" : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Give feedback" : _ctaText, ctaBefore = param.ctaBefore;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_card__WEBPACK_IMPORTED_MODULE_3__/* .Card */ .Zb, {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("border-0 bg-teal-100 relative", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_card__WEBPACK_IMPORTED_MODULE_3__/* .CardHeader */ .Ol, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_card__WEBPACK_IMPORTED_MODULE_3__/* .CardTitle */ .ll, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_card__WEBPACK_IMPORTED_MODULE_3__/* .CardDescription */ .SZ, {
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_card__WEBPACK_IMPORTED_MODULE_3__/* .CardContent */ .aY, {
                children: ctaBefore
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_card__WEBPACK_IMPORTED_MODULE_3__/* .CardFooter */ .eW, {
                children: ctaText && onClick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                    variant: "outline",
                    onClick: onClick,
                    children: ctaText
                }) : null
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GiveFeedbackCta);


/***/ }),

/***/ 47460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SeoTags = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.config)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            props.config.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: props.config.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: props.config.title
                    })
                ]
            }) : null,
            props.config.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: props.config.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.config.description
                    })
                ]
            }) : null,
            props.config.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.config.keywords
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "//casehub.pro/og.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoTags);


/***/ }),

/***/ 11340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SigninConditionalRenderer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./util/auth.tsx + 1 modules
var util_auth = __webpack_require__(19475);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/utils.ts + 11 modules
var utils = __webpack_require__(74183);
// EXTERNAL MODULE: ./components/ui/typography.tsx
var typography = __webpack_require__(58020);
// EXTERNAL MODULE: ./components/ui/button.tsx
var ui_button = __webpack_require__(35739);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/DummyBox.tsx






var DummyBox = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,utils.cn)("py-4 px-6 backdrop-blur-[4px] bg-white flex items-center justify-center flex-col gap-4", props.className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: "h5",
                        className: "text-center",
                        children: props.title
                    }) : null,
                    props.subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        variant: "p",
                        className: "text-center",
                        children: props.subtitle
                    }) : null
                ]
            }),
            props.buttonText && props.buttonPath ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: props.buttonPath,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    variant: "secondary",
                    size: "sm",
                    asChild: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: props.buttonText
                    })
                })
            }) : null
        ]
    });
};
/* harmony default export */ var components_DummyBox = (DummyBox);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./components/SigninConditionalRenderer.tsx







var SigninConditionalRenderer = function(param) {
    var buttonText = param.buttonText, children = param.children, _mode = param.mode, mode = _mode === void 0 ? "replace" : _mode, title = param.title, _authRequired = param.authRequired, authRequired = _authRequired === void 0 ? true : _authRequired;
    var auth = (0,util_auth/* useAuth */.aC)();
    var router = (0,next_router.useRouter)();
    if (auth.isAuthenticated || !authRequired) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    if (mode === "replace") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DummyBox, {
            className: "my-4",
            title: title,
            buttonText: buttonText,
            buttonPath: "/auth/signin?next=".concat(encodeURIComponent(router.asPath))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("relative group", (0,_define_property/* default */.Z)({}, "overflow-hidden hover:", mode === "overlay")),
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DummyBox, {
                className: (0,clsx_m/* default */.Z)("absolute inset-0 z-10 group:hover:opacity-1 group-hover:pointer-events-auto", (0,_define_property/* default */.Z)({}, "pointer-events-none opacity-0 absolute transition-opacity duration-300 inset-0", mode === "overlay")),
                title: title,
                buttonText: buttonText,
                buttonPath: "/auth/signin?next=".concat(encodeURIComponent(router.asPath))
            })
        ]
    });
};
/* harmony default export */ var components_SigninConditionalRenderer = (SigninConditionalRenderer);


/***/ }),

/***/ 30346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CommentsSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58020);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35739);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5097);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46035);
/* harmony import */ var _features_commentsSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12763);
/* harmony import */ var _features_usersSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97219);
/* harmony import */ var _components_UserAvatar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8222);
/* harmony import */ var _util_format__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16685);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(87536);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1604);
/* harmony import */ var _hookform_resolvers_zod__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(56312);
/* harmony import */ var _components_ui_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27946);
/* harmony import */ var _components_ui_textarea__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61784);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(74183);
/* harmony import */ var pluralize__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23450);
/* harmony import */ var pluralize__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(pluralize__WEBPACK_IMPORTED_MODULE_11__);





















var CommentsSection = function(param) {
    var comments = param.comments, user = param.user, onSubmitCommentButtonClick = param.onSubmitCommentButtonClick, onSubmitReplyButtonClick = param.onSubmitReplyButtonClick, onFetchReply = param.onFetchReply, _showCommentsList = param.showCommentsList, showCommentsList = _showCommentsList === void 0 ? true : _showCommentsList;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_3__.useState(null), 2), replyToCommentId = ref[0], setReplyToCommentId = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_3__.useState({}), 2), activeCommentIds = ref1[0], setActiveCommentIds = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_3__.useState(false), 2), isMainReplyFormActive = ref2[0], setIsMainReplyFormActive = ref2[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-6 flex flex-col justify-start items-start my-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z, {
                variant: "h3",
                children: "Members’ reactions"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pt-4 w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z, {
                        className: "text-sm text-gray-800 mb-2",
                        children: [
                            (0,_util_format__WEBPACK_IMPORTED_MODULE_8__/* .formatName */ .KY)(user),
                            ", what are your thoughts?"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex w-full mb-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReplyForm, {
                            collapsed: !isMainReplyFormActive,
                            onFocus: function() {
                                setIsMainReplyFormActive(true);
                            },
                            placeholder: "Join the conversation, share your thoughts or questions with the CaseHub community.",
                            onSubmitCommentButtonClick: function(text) {
                                onSubmitCommentButtonClick(text);
                                setIsMainReplyFormActive(false);
                            },
                            onCancelButtonClick: function() {
                                setIsMainReplyFormActive(false);
                            }
                        })
                    })
                ]
            }),
            showCommentsList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommentsList, {
                level: 0,
                comments: comments,
                replyToCommentId: replyToCommentId,
                setReplyToCommentId: setReplyToCommentId,
                activeCommentIds: activeCommentIds,
                onSubmitCommentButtonClick: function(id, text) {
                    if (!user) {
                        return null;
                    }
                    onSubmitReplyButtonClick(id, text);
                },
                onShowRepliesButtonClick: function(id) {
                    var isVisible = !activeCommentIds[id];
                    setActiveCommentIds((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, activeCommentIds), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, id, isVisible)));
                    if (isVisible) {
                        onFetchReply(id);
                    }
                }
            }) : null
        ]
    });
};
var CommentsList = function(param) {
    var comments = param.comments, level = param.level, replyToCommentId = param.replyToCommentId, onSubmitCommentButtonClick = param.onSubmitCommentButtonClick, onShowRepliesButtonClick = param.onShowRepliesButtonClick, setReplyToCommentId = param.setReplyToCommentId, activeCommentIds = param.activeCommentIds, rootCommentId = param.rootCommentId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col justify-start items-start w-full",
        children: comments.map(function(id) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comment, {
                level: level,
                commentId: id,
                rootCommentId: rootCommentId,
                activeCommentIds: activeCommentIds,
                replyToCommentId: replyToCommentId,
                replyFormVisible: replyToCommentId === id,
                setReplyToCommentId: setReplyToCommentId,
                onSubmitCommentButtonClick: onSubmitCommentButtonClick,
                onShowRepliesButtonClick: onShowRepliesButtonClick
            }, id);
        })
    });
};
var Comment = function(param) {
    var commentId = param.commentId, rootCommentId = param.rootCommentId, level = param.level, replyToCommentId = param.replyToCommentId, activeCommentIds = param.activeCommentIds, replyFormVisible = param.replyFormVisible, setReplyToCommentId = param.setReplyToCommentId, onSubmitCommentButtonClick = param.onSubmitCommentButtonClick, onShowRepliesButtonClick = param.onShowRepliesButtonClick;
    var ref;
    var comment = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_features_commentsSlice__WEBPACK_IMPORTED_MODULE_5__/* .selectCommentById */ .o1)(state, commentId);
    });
    var childComments = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_features_commentsSlice__WEBPACK_IMPORTED_MODULE_5__/* .selectCommentsIdsByParentId */ .Ni)(state, commentId);
    });
    var commentAuthor = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_features_usersSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectUserById */ .Ls)(state, comment === null || comment === void 0 ? void 0 : comment.user);
    });
    if (!comment || !comment.content || (comment === null || comment === void 0 ? void 0 : (ref = comment.content) === null || ref === void 0 ? void 0 : ref.length) < 3) {
        return null;
    }
    if (level === 0 && comment.parent_id) {
        return null;
    }
    var isRepliesFormOpened = activeCommentIds[comment.id];
    var _obj, _obj1, _obj2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_16__.cn)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, "w-full", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, "border-l-[1px] border-gray-400", level === 1), // ['py-4']: level === 1,
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj, "pl-8", level === 1), _obj)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_16__.cn)((_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj1, "border-b-[1px] border-gray-200", !isRepliesFormOpened || level > 0), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj1, "py-6", true), _obj1)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_16__.cn)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, "flex space-x-4 w-full", true)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UserAvatar__WEBPACK_IMPORTED_MODULE_7__/* .UserAvatar */ .Y, {
                                userId: comment.user
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-start w-full space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm font-medium leading-none",
                                                children: (0,_util_format__WEBPACK_IMPORTED_MODULE_8__/* .formatName */ .KY)(commentAuthor)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-xs text-muted-foreground mb-2",
                                                children: (0,_util_format__WEBPACK_IMPORTED_MODULE_8__/* .formatRelativeDate */ .zg)(comment.created)
                                            }),
                                            (0,_util_format__WEBPACK_IMPORTED_MODULE_8__/* .prepareText */ .hN)(comment.content || "").map(function(line, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-sm text-gray-800",
                                                    dangerouslySetInnerHTML: {
                                                        __html: (0,_util_format__WEBPACK_IMPORTED_MODULE_8__/* .sanitizeCommentText */ .C5)(line)
                                                    }
                                                }, index);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex justify-between items-center w-full",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: comment.child_count > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                                    variant: "plain",
                                                    size: "subtle",
                                                    onClick: function() {
                                                        onShowRepliesButtonClick(comment.id);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                            className: "w-4 h-4"
                                                        }),
                                                        isRepliesFormOpened ? "Hide replies" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                comment.child_count,
                                                                " ",
                                                                pluralize__WEBPACK_IMPORTED_MODULE_11__("reply", comment.child_count)
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            }),
                                            !replyFormVisible && level < 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                                variant: "link",
                                                size: "sm",
                                                className: "font-bold",
                                                onClick: function() {
                                                    setReplyToCommentId(comment.id);
                                                },
                                                children: "Reply"
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    replyFormVisible ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_16__.cn)((_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj2, "mt-4", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj2, "pt-4", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj2, "px-6", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_obj2, "border-l-[1px] border-gray-400", true), _obj2)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReplyForm, {
                            placeholder: "Reply to this comment...",
                            onSubmitCommentButtonClick: function(text) {
                                onSubmitCommentButtonClick(rootCommentId || comment.id, text);
                                if (!isRepliesFormOpened) {
                                    onShowRepliesButtonClick(comment.id);
                                }
                                setReplyToCommentId(null);
                            },
                            onCancelButtonClick: function() {
                                setReplyToCommentId(null);
                            }
                        })
                    }) : null
                ]
            }),
            isRepliesFormOpened ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_16__.cn)({
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommentsList, {
                    level: level + 1,
                    rootCommentId: rootCommentId || comment.id,
                    comments: childComments,
                    activeCommentIds: activeCommentIds,
                    replyToCommentId: replyToCommentId,
                    setReplyToCommentId: setReplyToCommentId,
                    onSubmitCommentButtonClick: onSubmitCommentButtonClick,
                    onShowRepliesButtonClick: onShowRepliesButtonClick
                })
            }) : null
        ]
    });
};
var commentFormSchema = zod__WEBPACK_IMPORTED_MODULE_18__/* .object */ .Ry({
    comment: zod__WEBPACK_IMPORTED_MODULE_18__/* .string */ .Z_().min(3, {
        message: "Comment must be at least 3 characters."
    })
});
var ReplyForm = function(param) {
    var collapsed = param.collapsed, onFocus = param.onFocus, onSubmitCommentButtonClick = param.onSubmitCommentButtonClick, onCancelButtonClick = param.onCancelButtonClick, placeholder = param.placeholder;
    var onSubmit = function onSubmit(values) {
        if (typeof onSubmitCommentButtonClick === "function") {
            onSubmitCommentButtonClick(values.comment);
            form.reset();
        }
    };
    var form = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_19__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_zod__WEBPACK_IMPORTED_MODULE_20__/* .zodResolver */ .F)(commentFormSchema),
        defaultValues: {
            comment: ""
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_9__/* .Form */ .l0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, form), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            onSubmit: form.handleSubmit(onSubmit),
            className: "space-y-4 w-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_9__/* .FormField */ .Wi, {
                    control: form.control,
                    name: "comment",
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_form__WEBPACK_IMPORTED_MODULE_9__/* .FormItem */ .xJ, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_9__/* .FormControl */ .NI, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_textarea__WEBPACK_IMPORTED_MODULE_10__/* .Textarea */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                                        placeholder: placeholder,
                                        onFocus: onFocus
                                    }, field), {
                                        rows: collapsed ? 1 : 5,
                                        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_16__.cn)("bg-white", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, "min-h-[10px]", collapsed))
                                    }))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_9__/* .FormMessage */ .zG, {})
                            ]
                        });
                    }
                }),
                collapsed ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full justify-end items-center gap-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                            type: "button",
                            size: "sm",
                            variant: "ghost",
                            onClick: onCancelButtonClick,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                            type: "submit",
                            size: "sm",
                            children: "Respond"
                        })
                    ]
                })
            ]
        })
    }));
};


/***/ }),

/***/ 2719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _util_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19475);
/* harmony import */ var _SigninConditionalRenderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11340);




function VideoEmbed(props) {
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)();
    var authRequired = props.authRequired !== undefined ? props.authRequired : !!props.thumb;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SigninConditionalRenderer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: "You must be logged in to access this content",
        buttonText: "Log in to continue",
        mode: "overlay",
        authRequired: authRequired,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
            className: "aspect-video w-full mb-0",
            children: authRequired && !auth.isAuthenticated ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: props.thumb,
                alt: ""
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                title: "Video",
                style: {
                    height: "100%",
                    width: "100%"
                },
                src: props.url,
                allowFullScreen: true,
                frameBorder: 0
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (VideoEmbed);


/***/ }),

/***/ 84889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _VideoEmbed__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2719);
/* harmony import */ var _components_ui_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58020);




var VideoCard = function(props) {
    if (!props.embedUrl && !props.thumb) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                        variant: "p",
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                        variant: "muted",
                        children: props.date
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                        variant: "p",
                        children: props.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VideoEmbed__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    url: props.embedUrl,
                    thumb: props.thumb,
                    authRequired: props.authRequired
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoCard);


/***/ }),

/***/ 18091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ToolboxAddReactionForm; },
/* harmony export */   "x": function() { return /* binding */ CaseAddReactionForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87536);
/* harmony import */ var _features_thunks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32132);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46035);
/* harmony import */ var _util_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19475);
/* harmony import */ var _features_casesSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94916);
/* harmony import */ var _features_toolboxSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67576);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1604);
/* harmony import */ var _hookform_resolvers_zod__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56312);
/* harmony import */ var _components_ui_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27946);
/* harmony import */ var _components_ui_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35739);
/* harmony import */ var _components_ui_textarea__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61784);















var formSchema = zod__WEBPACK_IMPORTED_MODULE_10__/* .object */ .Ry({
    comment: zod__WEBPACK_IMPORTED_MODULE_10__/* .string */ .Z_().min(3, {
        message: "Comment must be at least 3 characters."
    })
});
var CaseAddReactionForm = function(param) {
    var caseId = param.caseId, onSubmitCommentButtonClick = param.onSubmitCommentButtonClick, afterCommentSubmitted = param.afterCommentSubmitted, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Add comment" : _ctaText, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "What are your thoughts?" : _placeholder;
    var currentCase = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_features_casesSlice__WEBPACK_IMPORTED_MODULE_5__/* .selectCaseById */ .pJ)(state, caseId);
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    if (!currentCase) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddReactionForm, {
        ctaText: ctaText,
        placeholder: placeholder,
        onSubmitCommentButtonClick: function(comment) {
            if (!(auth === null || auth === void 0 ? void 0 : auth.user)) {
                return null;
            }
            dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_2__/* .commentCase */ .rD)({
                caseId: caseId,
                comment: comment,
                userId: auth.user.id
            })).then(function() {
                if (afterCommentSubmitted && typeof afterCommentSubmitted === "function") {
                    afterCommentSubmitted();
                }
            });
            if (onSubmitCommentButtonClick && typeof onSubmitCommentButtonClick === "function") {
                onSubmitCommentButtonClick();
            }
        }
    });
};
var ToolboxAddReactionForm = function(param) {
    var toolboxId = param.toolboxId, toolId = param.toolId, placeholder = param.placeholder, onSubmitCommentButtonClick = param.onSubmitCommentButtonClick, afterCommentSubmitted = param.afterCommentSubmitted, ctaText = param.ctaText;
    var currentToolbox = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return (0,_features_toolboxSlice__WEBPACK_IMPORTED_MODULE_6__/* .selectToolboxById */ .Km)(state, toolboxId || "");
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    if (!currentToolbox) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddReactionForm, {
        placeholder: placeholder,
        ctaText: ctaText,
        onSubmitCommentButtonClick: function(comment) {
            if (!(auth === null || auth === void 0 ? void 0 : auth.user)) {
                return;
            }
            if (toolId) {
                dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_2__/* .commentToolboxTool */ .FP)({
                    toolId: toolId,
                    comment: comment,
                    userId: auth.user.id
                })).then(function() {
                    if (afterCommentSubmitted && typeof afterCommentSubmitted === "function") {
                        afterCommentSubmitted();
                    }
                });
            } else if (toolboxId) {
                dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_2__/* .commentToolbox */ .qc)({
                    toolboxId: toolboxId,
                    comment: comment,
                    userId: auth.user.id
                })).then(function() {
                    if (afterCommentSubmitted && typeof afterCommentSubmitted === "function") {
                        afterCommentSubmitted();
                    }
                });
            }
            if (onSubmitCommentButtonClick && typeof onSubmitCommentButtonClick === "function") {
                onSubmitCommentButtonClick(comment);
            }
        }
    });
};
var AddReactionForm = function(param) {
    var onSubmitCommentButtonClick = param.onSubmitCommentButtonClick, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "What are your thoughts?" : _placeholder, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Add comment" : _ctaText;
    var onSubmit = function onSubmit(values) {
        if (typeof onSubmitCommentButtonClick === "function") {
            onSubmitCommentButtonClick(values.comment);
            form.reset();
        }
    };
    var form = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_zod__WEBPACK_IMPORTED_MODULE_12__/* .zodResolver */ .F)(formSchema),
        defaultValues: {
            comment: ""
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_7__/* .Form */ .l0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, form), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            onSubmit: form.handleSubmit(onSubmit),
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_7__/* .FormField */ .Wi, {
                    control: form.control,
                    name: "comment",
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_form__WEBPACK_IMPORTED_MODULE_7__/* .FormItem */ .xJ, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_7__/* .FormControl */ .NI, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_textarea__WEBPACK_IMPORTED_MODULE_9__/* .Textarea */ .g, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                                        placeholder: placeholder
                                    }, field), {
                                        className: "bg-backgroundBrand"
                                    }))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_form__WEBPACK_IMPORTED_MODULE_7__/* .FormMessage */ .zG, {})
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_button__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                    type: "submit",
                    children: ctaText
                })
            ]
        })
    }));
};


/***/ }),

/***/ 64345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ol": function() { return /* binding */ CardHeader; },
/* harmony export */   "SZ": function() { return /* binding */ CardDescription; },
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "aY": function() { return /* binding */ CardContent; },
/* harmony export */   "eW": function() { return /* binding */ CardFooter; },
/* harmony export */   "ll": function() { return /* binding */ CardTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74183);





var Card = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("rounded-lg border bg-card text-card-foreground shadow-sm", className)
    }, props));
});
Card.displayName = "Card";
var CardHeader = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("flex flex-col space-y-1.5 p-6", className)
    }, props));
});
CardHeader.displayName = "CardHeader";
var CardTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("text-2xl font-semibold leading-none tracking-tight", className)
    }, props));
});
CardTitle.displayName = "CardTitle";
var CardDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
CardDescription.displayName = "CardDescription";
var CardContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("p-6 pt-0", className)
    }, props));
});
CardContent.displayName = "CardContent";
var CardFooter = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)(" flex items-center p-6 pt-0", className)
    }, props));
});
CardFooter.displayName = "CardFooter";



/***/ }),

/***/ 70499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$N": function() { return /* binding */ DialogTitle; },
/* harmony export */   "Be": function() { return /* binding */ DialogDescription; },
/* harmony export */   "GG": function() { return /* binding */ DialogClose; },
/* harmony export */   "Vq": function() { return /* binding */ Dialog; },
/* harmony export */   "cN": function() { return /* binding */ DialogFooter; },
/* harmony export */   "cZ": function() { return /* binding */ DialogContent; },
/* harmony export */   "fK": function() { return /* binding */ DialogHeader; },
/* harmony export */   "hg": function() { return /* binding */ DialogTrigger; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12854);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41352);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74183);
"use client";








var Dialog = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
var DialogTrigger = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
var DialogClose = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8;
var DialogPortal = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal */ .h_, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)(className)
    }, props));
};
DialogPortal.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Portal.displayName */ .h_.displayName;
var DialogOverlay = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay */ .aV, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className)
    }, props));
});
DialogOverlay.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Overlay.displayName */ .aV.displayName;
var DialogContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DialogPortal, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogOverlay, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                ref: ref,
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg md:w-full", className)
            }, props), {
                children: [
                    children,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            }))
        ]
    });
});
DialogContent.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;
var DialogHeader = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col space-y-1.5 text-center sm:text-left", className)
    }, props));
};
DialogHeader.displayName = "DialogHeader";
var DialogFooter = function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className)
    }, props));
};
DialogFooter.displayName = "DialogFooter";
var DialogTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("text-lg font-semibold leading-none tracking-tight", className)
    }, props));
});
DialogTitle.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Title.displayName */ .Dx.displayName;
var DialogDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description */ .dk, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_5__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
DialogDescription.displayName = _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Description.displayName */ .dk.displayName;



/***/ }),

/***/ 27946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NI": function() { return /* binding */ FormControl; },
/* harmony export */   "Wi": function() { return /* binding */ FormField; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; },
/* harmony export */   "pf": function() { return /* binding */ FormDescription; },
/* harmony export */   "xJ": function() { return /* binding */ FormItem; },
/* harmony export */   "zG": function() { return /* binding */ FormMessage; }
/* harmony export */ });
/* unused harmony export useFormField */
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88426);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74183);
/* harmony import */ var _components_ui_label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93223);










var Form = react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .FormProvider */ .RV;
var FormFieldContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
var FormField = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormFieldContext.Provider, {
        value: {
            name: props.name
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .Controller */ .Qr, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props))
    });
};
var useFormField = function() {
    var fieldContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(FormFieldContext);
    var itemContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(FormItemContext);
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(), getFieldState = ref.getFieldState, formState = ref.formState;
    var fieldState = getFieldState(fieldContext.name, formState);
    if (!fieldContext) {
        throw new Error("useFormField should be used within <FormField>");
    }
    var id = itemContext.id;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: id,
        name: fieldContext.name,
        formItemId: "".concat(id, "-form-item"),
        formDescriptionId: "".concat(id, "-form-item-description"),
        formMessageId: "".concat(id, "-form-item-message")
    }, fieldState);
};
var FormItemContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
var FormItem = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var id = react__WEBPACK_IMPORTED_MODULE_1__.useId();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormItemContext.Provider, {
        value: {
            id: id
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            ref: ref,
            className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)("space-y-2", className)
        }, props))
    });
});
FormItem.displayName = "FormItem";
var FormLabel = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var _$ref = useFormField(), error = _$ref.error, formItemId = _$ref.formItemId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_label__WEBPACK_IMPORTED_MODULE_2__/* .Label */ ._, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)(error && "text-destructive", className),
        htmlFor: formItemId
    }, props));
});
FormLabel.displayName = "FormLabel";
var FormControl = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var _$ref = useFormField(), error = _$ref.error, formItemId = _$ref.formItemId, formDescriptionId = _$ref.formDescriptionId, formMessageId = _$ref.formMessageId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_8__/* .Slot */ .g7, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        id: formItemId,
        "aria-describedby": !error ? "".concat(formDescriptionId) : "".concat(formDescriptionId, " ").concat(formMessageId),
        "aria-invalid": !!error
    }, props));
});
FormControl.displayName = "FormControl";
var FormDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var formDescriptionId = useFormField().formDescriptionId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        id: formDescriptionId,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
FormDescription.displayName = "FormDescription";
var FormMessage = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    var _$ref = useFormField(), error = _$ref.error, formMessageId = _$ref.formMessageId;
    var body = error ? String(error === null || error === void 0 ? void 0 : error.message) : children;
    if (!body) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        id: formMessageId,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)("text-sm font-medium text-destructive", className)
    }, props), {
        children: body
    }));
});
FormMessage.displayName = "FormMessage";



/***/ }),

/***/ 93223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49102);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12003);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74183);
"use client";







var labelVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
var Label = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_label__WEBPACK_IMPORTED_MODULE_4__/* .Root */ .f, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__.cn)(labelVariants(), className)
    }, props));
});
Label.displayName = _radix_ui_react_label__WEBPACK_IMPORTED_MODULE_4__/* .Root.displayName */ .f.displayName;



/***/ }),

/***/ 61784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74183);





var Textarea = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className),
        ref: ref
    }, props));
});
Textarea.displayName = "Textarea";



/***/ }),

/***/ 58020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Typography; }
/* harmony export */ });
/* unused harmony export typographyVariants */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88426);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74183);







var typographyVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("", {
    variants: {
        variant: {
            default: "",
            h1: "scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl",
            h2: "scroll-m-20 pb-2 text-3xl font-semibold tracking-tight transition-colors first:mt-0",
            h3: "scroll-m-20 text-2xl font-semibold tracking-tight",
            h4: "scroll-m-20 text-xl font-semibold tracking-tight",
            h5: "scroll-m-20 text-lg font-semibold tracking-tight",
            h6: "scroll-m-20 text-sm font-semibold tracking-tight",
            p: "leading-7 [&:not(:first-child)]:mt-6",
            blockquote: "mt-6 border-l-2 pl-6 italic",
            lead: "text-xl text-muted-foreground",
            large: "text-lg font-semibold",
            small: "text-sm font-medium leading-none",
            muted: "text-xs text-muted-foreground",
            xs: "text-xs font-medium leading-none"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
var Typography = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, variant = _param.variant, _asChild = _param.asChild, asChild = _asChild === void 0 ? false : _asChild, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "variant",
        "asChild"
    ]);
    var Comp = asChild ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_4__/* .Slot */ .g7 : "p";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__.cn)(typographyVariants({
            variant: variant,
            className: className
        })),
        ref: ref
    }, props));
});
Typography.displayName = "Typography";



/***/ }),

/***/ 64616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KN": function() { return /* binding */ useAddCaseBookmarks; },
/* harmony export */   "S7": function() { return /* binding */ useBookmarks; },
/* harmony export */   "TV": function() { return /* binding */ useAddCaseToFavorites; },
/* harmony export */   "a3": function() { return /* binding */ useAddToolBookmarks; },
/* harmony export */   "gT": function() { return /* binding */ useAddToolToFavorites; }
/* harmony export */ });
/* unused harmony exports useDeleteCaseBookmarks, useDeleteToolBookmarks, useDeleteToolFavorites, useDeleteCaseFavorites */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _util_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19475);
/* harmony import */ var _util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80995);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46035);
/* harmony import */ var _features_thunks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32132);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _util_users__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46602);







var useAddCaseBookmarks = function(caseId) {
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .aC)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    return (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_1__/* .useStableCallback */ .R)(function() {
        if (!auth.isAuthenticated) {
            return;
        }
        dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_3__/* .addCaseToBookmarks */ .ik)({
            caseId: caseId
        }));
    });
};
var useDeleteCaseBookmarks = function(param) {
    var caseId = param.caseId, bookmarkId = param.bookmarkId;
    var auth = useAuth();
    var dispatch = useDispatch();
    return useStableCallback(function() {
        if (!auth.isAuthenticated) {
            return;
        }
        dispatch(deleteCaseFromBookmarks({
            caseId: caseId,
            bookmarkId: bookmarkId
        }));
    });
};
var useDeleteToolBookmarks = function(param) {
    var toolId = param.toolId, bookmarkId = param.bookmarkId;
    var auth = useAuth();
    var dispatch = useDispatch();
    return useStableCallback(function() {
        if (!auth.isAuthenticated) {
            return;
        }
        dispatch(deleteToolFromBookmarks({
            toolId: toolId,
            bookmarkId: bookmarkId
        }));
    });
};
var useDeleteToolFavorites = function(param) {
    var toolId = param.toolId, bookmarkId = param.bookmarkId;
    var auth = useAuth();
    var dispatch = useDispatch();
    return useStableCallback(function() {
        if (!auth.isAuthenticated) {
            return;
        }
        dispatch(deleteToolFromFavorites({
            toolId: toolId,
            bookmarkId: bookmarkId
        }));
    });
};
var useDeleteCaseFavorites = function(param) {
    var caseId = param.caseId, bookmarkId = param.bookmarkId;
    var auth = useAuth();
    var dispatch = useDispatch();
    return useStableCallback(function() {
        if (!auth.isAuthenticated) {
            return;
        }
        dispatch(deleteCaseFromFavorites({
            caseId: caseId,
            bookmarkId: bookmarkId
        }));
    });
};
var useAddCaseToFavorites = function(caseId) {
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .aC)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    return (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_1__/* .useStableCallback */ .R)(function() {
        if (!auth.isAuthenticated) {
            return;
        }
        dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_3__/* .addCaseToFavorites */ .Ro)({
            caseId: caseId
        }));
    });
};
var useAddToolToFavorites = function(toolId) {
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .aC)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    return (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_1__/* .useStableCallback */ .R)(function() {
        if (!auth.isAuthenticated) {
            return;
        }
        dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_3__/* .addToolToFavorites */ .RU)({
            toolId: toolId
        }));
    });
};
var useAddToolBookmarks = function(toolId) {
    var auth = (0,_util_auth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .aC)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    return (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_1__/* .useStableCallback */ .R)(function() {
        if (!auth.isAuthenticated) {
            return;
        }
        dispatch((0,_features_thunks__WEBPACK_IMPORTED_MODULE_3__/* .addToolToBookmarks */ .v0)({
            toolId: toolId
        }));
    });
};
var useBookmarks = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_4__.useState([]), 2), bookmarks = ref[0], setBookmarks = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        (0,_util_users__WEBPACK_IMPORTED_MODULE_5__/* .fetchCurrentUserBookmarks */ .S9)().then(function(bookmarks) {
            setBookmarks(bookmarks);
        });
    }, []);
    var deleteFromBookmarks = (0,_util_hooks_useStableCallback__WEBPACK_IMPORTED_MODULE_1__/* .useStableCallback */ .R)(function(bookmarkId) {
        (0,_util_users__WEBPACK_IMPORTED_MODULE_5__/* .postDeleteBookmark */ .Mu)(bookmarkId).then(function() {
            (0,_util_users__WEBPACK_IMPORTED_MODULE_5__/* .fetchCurrentUserBookmarks */ .S9)().then(function(bookmarks) {
                setBookmarks(bookmarks);
            });
        });
    });
    return [
        bookmarks,
        deleteFromBookmarks
    ];
};


/***/ }),

/***/ 2630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ createVideoUrl; },
/* harmony export */   "y": function() { return /* binding */ getVideoThumbnailPath; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);

var urlBuildersByProvider = {
    "vimeo": function(id) {
        return "https://player.vimeo.com/video/".concat(id);
    },
    "youtube": function(id) {
        return "https://www.youtube.com/embed/".concat(id);
    }
};
var createVideoUrl = function(video) {
    if (typeof video.video_id === "string" && video.video_id) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(video.video_id.split(":"), 2), provider = ref[0], id = ref[1];
        if (typeof urlBuildersByProvider[provider] === "function") {
            return urlBuildersByProvider[provider](id);
        }
    }
    if (video.vimeo_id) {
        return urlBuildersByProvider["vimeo"](video.vimeo_id);
    }
};
var getVideoThumbnailPath = function(video) {
    if (!video.id) {
        return;
    }
    return "/api/ch/videothumb/".concat(video.id);
};


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 23450:
/***/ (function(module) {

/* global define */

(function (root, pluralize) {
  /* istanbul ignore else */
  if (true) {
    // Node.
    module.exports = pluralize();
  } else {}
})(this, function () {
  // Rule storage - pluralize and singularize need to be run sequentially,
  // while other rules can be optimized using an object for instant lookups.
  var pluralRules = [];
  var singularRules = [];
  var uncountables = {};
  var irregularPlurals = {};
  var irregularSingles = {};

  /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */
  function sanitizeRule (rule) {
    if (typeof rule === 'string') {
      return new RegExp('^' + rule + '$', 'i');
    }

    return rule;
  }

  /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */
  function restoreCase (word, token) {
    // Tokens are an exact match.
    if (word === token) return token;

    // Lower cased words. E.g. "hello".
    if (word === word.toLowerCase()) return token.toLowerCase();

    // Upper cased words. E.g. "WHISKY".
    if (word === word.toUpperCase()) return token.toUpperCase();

    // Title cased words. E.g. "Title".
    if (word[0] === word[0].toUpperCase()) {
      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
    }

    // Lower cased words. E.g. "test".
    return token.toLowerCase();
  }

  /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */
  function interpolate (str, args) {
    return str.replace(/\$(\d{1,2})/g, function (match, index) {
      return args[index] || '';
    });
  }

  /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */
  function replace (word, rule) {
    return word.replace(rule[0], function (match, index) {
      var result = interpolate(rule[1], arguments);

      if (match === '') {
        return restoreCase(word[index - 1], result);
      }

      return restoreCase(match, result);
    });
  }

  /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */
  function sanitizeWord (token, word, rules) {
    // Empty string or doesn't need fixing.
    if (!token.length || uncountables.hasOwnProperty(token)) {
      return word;
    }

    var len = rules.length;

    // Iterate over the sanitization rules and use the first one to match.
    while (len--) {
      var rule = rules[len];

      if (rule[0].test(word)) return replace(word, rule);
    }

    return word;
  }

  /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */
  function replaceWord (replaceMap, keepMap, rules) {
    return function (word) {
      // Get the correct token and case restoration functions.
      var token = word.toLowerCase();

      // Check against the keep object map.
      if (keepMap.hasOwnProperty(token)) {
        return restoreCase(word, token);
      }

      // Check against the replacement map for a direct word replacement.
      if (replaceMap.hasOwnProperty(token)) {
        return restoreCase(word, replaceMap[token]);
      }

      // Run all the rules against the word.
      return sanitizeWord(token, word, rules);
    };
  }

  /**
   * Check if a word is part of the map.
   */
  function checkWord (replaceMap, keepMap, rules, bool) {
    return function (word) {
      var token = word.toLowerCase();

      if (keepMap.hasOwnProperty(token)) return true;
      if (replaceMap.hasOwnProperty(token)) return false;

      return sanitizeWord(token, token, rules) === token;
    };
  }

  /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */
  function pluralize (word, count, inclusive) {
    var pluralized = count === 1
      ? pluralize.singular(word) : pluralize.plural(word);

    return (inclusive ? count + ' ' : '') + pluralized;
  }

  /**
   * Pluralize a word.
   *
   * @type {Function}
   */
  pluralize.plural = replaceWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Check if a word is plural.
   *
   * @type {Function}
   */
  pluralize.isPlural = checkWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Singularize a word.
   *
   * @type {Function}
   */
  pluralize.singular = replaceWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Check if a word is singular.
   *
   * @type {Function}
   */
  pluralize.isSingular = checkWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addPluralRule = function (rule, replacement) {
    pluralRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addSingularRule = function (rule, replacement) {
    singularRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */
  pluralize.addUncountableRule = function (word) {
    if (typeof word === 'string') {
      uncountables[word.toLowerCase()] = true;
      return;
    }

    // Set singular and plural references for the word.
    pluralize.addPluralRule(word, '$0');
    pluralize.addSingularRule(word, '$0');
  };

  /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */
  pluralize.addIrregularRule = function (single, plural) {
    plural = plural.toLowerCase();
    single = single.toLowerCase();

    irregularSingles[single] = plural;
    irregularPlurals[plural] = single;
  };

  /**
   * Irregular rules.
   */
  [
    // Pronouns.
    ['I', 'we'],
    ['me', 'us'],
    ['he', 'they'],
    ['she', 'they'],
    ['them', 'them'],
    ['myself', 'ourselves'],
    ['yourself', 'yourselves'],
    ['itself', 'themselves'],
    ['herself', 'themselves'],
    ['himself', 'themselves'],
    ['themself', 'themselves'],
    ['is', 'are'],
    ['was', 'were'],
    ['has', 'have'],
    ['this', 'these'],
    ['that', 'those'],
    // Words ending in with a consonant and `o`.
    ['echo', 'echoes'],
    ['dingo', 'dingoes'],
    ['volcano', 'volcanoes'],
    ['tornado', 'tornadoes'],
    ['torpedo', 'torpedoes'],
    // Ends with `us`.
    ['genus', 'genera'],
    ['viscus', 'viscera'],
    // Ends with `ma`.
    ['stigma', 'stigmata'],
    ['stoma', 'stomata'],
    ['dogma', 'dogmata'],
    ['lemma', 'lemmata'],
    ['schema', 'schemata'],
    ['anathema', 'anathemata'],
    // Other irregular rules.
    ['ox', 'oxen'],
    ['axe', 'axes'],
    ['die', 'dice'],
    ['yes', 'yeses'],
    ['foot', 'feet'],
    ['eave', 'eaves'],
    ['goose', 'geese'],
    ['tooth', 'teeth'],
    ['quiz', 'quizzes'],
    ['human', 'humans'],
    ['proof', 'proofs'],
    ['carve', 'carves'],
    ['valve', 'valves'],
    ['looey', 'looies'],
    ['thief', 'thieves'],
    ['groove', 'grooves'],
    ['pickaxe', 'pickaxes'],
    ['passerby', 'passersby']
  ].forEach(function (rule) {
    return pluralize.addIrregularRule(rule[0], rule[1]);
  });

  /**
   * Pluralization rules.
   */
  [
    [/s?$/i, 's'],
    [/[^\u0000-\u007F]$/i, '$0'],
    [/([^aeiou]ese)$/i, '$1'],
    [/(ax|test)is$/i, '$1es'],
    [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
    [/(e[mn]u)s?$/i, '$1s'],
    [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
    [/(seraph|cherub)(?:im)?$/i, '$1im'],
    [/(her|at|gr)o$/i, '$1oes'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
    [/sis$/i, 'ses'],
    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/([^ch][ieo][ln])ey$/i, '$1ies'],
    [/(x|ch|ss|sh|zz)$/i, '$1es'],
    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
    [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
    [/(pe)(?:rson|ople)$/i, '$1ople'],
    [/(child)(?:ren)?$/i, '$1ren'],
    [/eaux$/i, '$0'],
    [/m[ae]n$/i, 'men'],
    ['thou', 'you']
  ].forEach(function (rule) {
    return pluralize.addPluralRule(rule[0], rule[1]);
  });

  /**
   * Singularization rules.
   */
  [
    [/s$/i, ''],
    [/(ss)$/i, '$1'],
    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
    [/ies$/i, 'y'],
    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
    [/\b(mon|smil)ies$/i, '$1ey'],
    [/\b((?:tit)?m|l)ice$/i, '$1ouse'],
    [/(seraph|cherub)im$/i, '$1'],
    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
    [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
    [/(test)(?:is|es)$/i, '$1is'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
    [/(alumn|alg|vertebr)ae$/i, '$1a'],
    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
    [/(matr|append)ices$/i, '$1ix'],
    [/(pe)(rson|ople)$/i, '$1rson'],
    [/(child)ren$/i, '$1'],
    [/(eau)x?$/i, '$1'],
    [/men$/i, 'man']
  ].forEach(function (rule) {
    return pluralize.addSingularRule(rule[0], rule[1]);
  });

  /**
   * Uncountable rules.
   */
  [
    // Singular words with no plurals.
    'adulthood',
    'advice',
    'agenda',
    'aid',
    'aircraft',
    'alcohol',
    'ammo',
    'analytics',
    'anime',
    'athletics',
    'audio',
    'bison',
    'blood',
    'bream',
    'buffalo',
    'butter',
    'carp',
    'cash',
    'chassis',
    'chess',
    'clothing',
    'cod',
    'commerce',
    'cooperation',
    'corps',
    'debris',
    'diabetes',
    'digestion',
    'elk',
    'energy',
    'equipment',
    'excretion',
    'expertise',
    'firmware',
    'flounder',
    'fun',
    'gallows',
    'garbage',
    'graffiti',
    'hardware',
    'headquarters',
    'health',
    'herpes',
    'highjinks',
    'homework',
    'housework',
    'information',
    'jeans',
    'justice',
    'kudos',
    'labour',
    'literature',
    'machinery',
    'mackerel',
    'mail',
    'media',
    'mews',
    'moose',
    'music',
    'mud',
    'manga',
    'news',
    'only',
    'personnel',
    'pike',
    'plankton',
    'pliers',
    'police',
    'pollution',
    'premises',
    'rain',
    'research',
    'rice',
    'salmon',
    'scissors',
    'series',
    'sewage',
    'shambles',
    'shrimp',
    'software',
    'species',
    'staff',
    'swine',
    'tennis',
    'traffic',
    'transportation',
    'trout',
    'tuna',
    'wealth',
    'welfare',
    'whiting',
    'wildebeest',
    'wildlife',
    'you',
    /pok[eé]mon$/i,
    // Regexes.
    /[^aeiou]ese$/i, // "chinese", "japanese"
    /deer$/i, // "deer", "reindeer"
    /fish$/i, // "fish", "blowfish", "angelfish"
    /measles$/i,
    /o[iu]s$/i, // "carnivorous"
    /pox$/i, // "chickpox", "smallpox"
    /sheep$/i
  ].forEach(pluralize.addUncountableRule);

  return pluralize;
});


/***/ })

}]);